<script setup>
import { ref, watch } from 'vue';

const props = defineProps({
    id: {
        type: [Number, String],
        default: null,
    },
    slug: {
        type: String,
        default: null,
    },
});

const title = ref(null);
let requestNumber = 0;

const loadTitle = async () => {
    const currentRequest = ++requestNumber;
    title.value = null;

    if (!props.id && !props.slug) {
        return;
    }

    const params = props.id ? { id: props.id } : { slug: props.slug };

    try {
        const response = await axios.get(
            route('api.pages.title'),
            { params }
        );

        if (currentRequest === requestNumber) {
            title.value = response.data.page.title;
        }
    } catch (error) {
        if (currentRequest === requestNumber) {
            title.value = null;
        }
    }
};

watch(() => [props.id, props.slug], loadTitle, { immediate: true });
</script>

<template>
    <span v-if="title" aria-live="polite">{{ title }}</span>
</template>
